import $ from '../lib/jquery';

import { Component } from '../core/component';
import { http } from '../core/http';

export class MiniCalendar extends Component {
    selector = '.js-mini-cal';

    init() {
        this.$elements.each((index, element) => {
            const $element = $(element);
            $element.on('click', '.js-mini-cal-nav', (evt) => {
                this.onNavClick(evt, $element);
            });
        });
    }

    onNavClick = async (evt, $element) => {
        const url = $(evt.currentTarget).data('url');

        let markup;

        try {
            const res = await http.get(url);
            markup = res.data;
        } catch (err) {
            // eslint-disable-next-line no-alert
            window.alert('There was a problem fetching the next calendar page, try again later');
        }

        $element.html(markup);
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/MiniCalendar.js